import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App';
import reportWebVitals from './reportWebVitals';
import './index.less';

const strict_mode: boolean = true;

ReactDOM.render(
    (strict_mode ? <React.StrictMode>
        <App/>
    </React.StrictMode> : <App/>),
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
